/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
==========================================================================================*/
import UserTaxAPI from '@/api/UserTaxAPI.js';
import AmisAPI from '@/api/AmisAPI.js';
import httpClient from '../../api/axios-httpclient';
import { MSEnum } from '@/common/enumeration';

export default {
	loadUserList: async function(context, payload) {
		context.commit('updateUserListLoaded', false);
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrl() + '/paging',
			data: payload
		});
		if (res.Success) context.commit('updateUserList', res);
		context.commit('updateUserListLoaded', true);
		return res.Data;
	},
	deleteUserList: async function(context, options) {
		let res = await httpClient.postAsync(
			{
				url: UserTaxAPI.getAPIUrl() + '/delete',
				data: options.payload
			},
			true
		);
		if (res.Success) context.commit('deleteUser', options.item);
		return res;
	},
	checkUserTaxExist: async function(context, payload) {
		return await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrl() + `/taxcodeexist/${payload.TaxCode}`,
			data: payload
		});
	},
	getUsersAmis: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: AmisAPI.getAPIUrl() + '/users',
				params: payload
			},
			true
		);
		return res && res.Success ? res.Data : null;
	},
	addAmisUser: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: UserTaxAPI.getAPIUrl() + '/add-amis-user',
				data: payload
			},
			true
		);
	},
	updateAmisConvertSeenNotification: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrl() + '/updateamisconvertseennotification'
		});
		if (res && res.Success && res.Data) {
			context.commit('updateAmisConvertStatus', {
				MisaId: payload.MisaId,
				TaxCode: payload.TaxCode,
				AmisConvertStatus:
					MSEnum.AmisConvertStatus.ConvertedAndSeenNotification
			});
		}
		return res;
	}
};
